module.exports = __webpack_public_path__ + "assets/img/tj_search_head_Icon.a2c15d82.png";